var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.085 8.217a.646.646 0 01-.914.914L4.989 5.925 1.784 9.13a.646.646 0 01-.914-.914l3.206-3.204L.869 1.783A.646.646 0 011.783.87L4.99 4.1 8.194.894a.646.646 0 01.914.914L5.902 5.012l3.183 3.205z",
    fill: "#CA2608"
  })));
}

export default SvgIconCross;